import { defineComponent } from "vue";
import decimalService from "@/services/decimal.service";
import dateFormatService from "@/services/date-format.service";
import { useToast } from "vue-toastification";
import VueCookie from "vue-cookie";
import customerService from "@/services/customer.service";

export default defineComponent({
   name: "customer-profile",
   setup() {
      const toast = useToast();
      return { toast };
   },
   filters: {
   },
   data() {
      return {
         customerId: '',
         customer: {
            name: '',
            ic_no: '',
            mobile_no: '',
            email: '',
         },
         validationTriggered: false,
         customerValidationTriggered: false,
         serverError: false,
         serverErrorMessage: '',
         newPassword: '',
         confirmNewPassword: '',
         currentPassword: ''
         };
   },
   methods: {
      getUser() {
         const loader = this.$loading.show();
         return customerService.getCustomerDetail(this.customerId).then(result => {
            this.customer = result.data.data;
            const keys = [ 'customer_name', 'email', 'ic_no', 'mobile_no' ];
            Object.keys(this.customer).forEach((key) => keys.includes(key) || delete this.customer[key]);
            loader.hide();
         })
         .catch(error => {
            console.error('error:', error);
            loader.hide();
         });
      },
      changePassword() {
         this.validationTriggered = true;
         this.serverError = false;
         this.serverErrorMessage = '';

         if (this.newPassword == '' ||
            this.confirmNewPassword == '' ||
            this.confirmNewPassword != this.newPassword) {
            return;
         }

         const loader = this.$loading.show();
         // let userObj = JSON.parse(VueCookie.get("user"));
         // userObj = JSON.parse(userObj);
         return customerService.customerChangePassword(this.customerId,{
            'id_user': this.customerId,
            'current_password': this.currentPassword,
            'new_password': this.newPassword,
         }).then(result => {
            this.validationTriggered = false;
            this.newPassword = '';
            this.confirmNewPassword = '';
            this.toast.success("Password Successfully Changed");
            loader.hide();
         })
         .catch(error => {
            this.serverError = true;
            this.validationTriggered = false;
            this.serverErrorMessage = error.response.data.error;
            this.toast.error(error.response.data.error);
            console.error('error:', error);
            loader.hide();
         });
      },
      updateCustomer() {
         this.customerValidationTriggered = true;
         if (this.customer.name == '' ||
            this.customer.ic_no == '' ||
            this.customer.mobile_no == '' ) {
            return;
         }
         const loader = this.$loading.show();
         return customerService.editCustomer(this.customerId, this.customer).then(result => {
            loader.hide();
            VueCookie.set("name", result.data.data.customer_name);
            this.toast.success("Profile Successfully Updated");
            setTimeout(() => this.$router.go(0), 1000);
         })
         .catch(error => {
            console.error('error:', error);
            this.toast.error(error.response.data.error);
            loader.hide();
         });
      },
      formatDate(date: string) {
         return dateFormatService.formatDate(date);
      },
      formatDateTime(date: string) {
         return dateFormatService.formatDateTime(date);
      },
      formatDatePeriod(date: string) {
         return dateFormatService.formatDatePeriod(date);
      },
      convertTo2Decimal(number) {
         return decimalService.formatNumberTo2Decimal(number);
      },
   },
   mounted() {
      this.customerId = JSON.parse(VueCookie.get("user")).id_customer;
      this.getUser();
   },
});
